import {t} from "@lingui/macro";
import type {ParsedMessage} from "../../types/types";

export function removeEmoji(str: string) {
    return str.replace(/[\p{Emoji}]/gu, (match) => (/\d/.test(match) ? match : ""));
}

export function cleanContent(content: any) {
    return content.map((item: any) => ({
        ...item,
        value: typeof item.value === "string" ? removeEmoji(item.value) : item.value,
    }));
}

export function getRequestId(messages: any) {
    let requestId = "";
    if (
        messages.some(
            (message: ParsedMessage) =>
                message.role === "system" && (message.content as any)?.status === "done",
        )
    ) {
        requestId =
            messages.find(
                (message: ParsedMessage) =>
                    message.role === "system" &&
                    (message.content as any)?.status === "done",
            )?.content?.request_id || "";
    }
    return requestId;
}

export const getErrorMessage = (code: number) => {
    switch (code) {
        case 500:
            return t`Tyvärr kan jag inte besvara den här frågan just nu. Prova att formulera om din fråga eller kom tillbaka om en stund.`;
        case 503:
            return t`Din förfrågan tog lite för lång tid för mig att hantera. Prova gärna att dela upp den i kortare delar.`;
        case 400:
        case 401:
            return t`Just nu har vi tekniska problem. Prova gärna igen om några minuter.`;
        case 404:
            return t`Någonting gick fel vid laddning av svaret.`;
        default:
            return t`Oops, någonting gick fel. Vänligen försök igen.`;
    }
};

export function withMinimumDelay<T>(promise: Promise<T>, minDelayMs: number): Promise<T> {
    return Promise.all([
        promise,
        // eslint-disable-next-line no-promise-executor-return
        new Promise<void>((resolve) => setTimeout(resolve, minDelayMs)),
    ]).then(([result]) => result);
}
